import { FC, useEffect, useMemo } from 'react'

import { SiteApplicationResponseHeader } from './SiteApplicationResponseHeader'
import { SiteApplicationResponseForm } from './SiteApplicationResponseForm'
import { DLMSiteApplication, extractModelFromSite } from '../../../core/doclabel'

type Props = {
    site: DLMSiteApplication
    workflow: string
    doClose: Function
}

const SiteApplicationResponseModal: FC<Props> = ({site, workflow, doClose}) => {

    const { siteState, siteID, appID, siteROIS } = useMemo(() => {
        if (! site) return { siteState : '', siteID : 0, appID: 0, siteROIS: []};
        const { state: siteState, id: siteID, dlmApplication } = site;
        const { id: appID  } = dlmApplication;
        
        let siteROIS : any[] = [];
        let payload = extractModelFromSite(site, siteState, 'TYPE_LABEL')
        if (payload) {
            siteROIS.push(payload);
        }
        return { siteState, siteID, appID, siteROIS } 
    }, [site]);
    
    useEffect(() => {
        document.body.classList.add('modal-open')
        return () => {
            document.body.classList.remove('modal-open')
        }
    }, [])

    return (
    <>
    <div
        className='modal fade show d-block'
        id='kt_modal_site_application_response'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
    >    
        <div className='modal-dialog modal-dialog-centered mw-600px'>    
            <div className='modal-content'>
                <SiteApplicationResponseHeader siteState={siteState} doClose={doClose} />                
                <div className='modal-body py-4'>
                    <SiteApplicationResponseForm 
                        siteID={siteID} 
                        siteState={siteState} 
                        appID={appID ? appID : 0}
                        siteROIS={siteROIS}
                        workflow={workflow}
                        doClose={doClose}                     
                    />
                </div>                
            </div>            
        </div>            
    </div>    
    <div className='modal-backdrop fade show'></div>    
    </>
    )
}

export {SiteApplicationResponseModal}
